module.exports = __webpack_public_path__ + "img/id_photo_example.2b74b599.png";